"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "Where exactly is the ceremony taking place?",
  answer: "Our ceremony will be held at the Stone Manor Estate. The venue is nestled in the rolling hills, providing a serene and romantic backdrop for our vows. Detailed directions and a map are available on 'The Big Day' page."
}, {
  question: "What is the dress code for the celebration?",
  answer: "We would love to see our guests in Black Tie Optional attire. Think elegant floor-length gowns, sophisticated cocktail dresses, or sharp tuxedos and dark suits. We want everyone to feel their most glamorous for this special evening."
}, {
  question: "Are children invited to the wedding?",
  answer: "While we love your little ones, our wedding will be an adults-only celebration. We hope you will enjoy this night off to celebrate with us! If you need assistance finding local childcare services, please let us know."
}, {
  question: "When should I RSVP by?",
  answer: "We kindly ask that you submit your RSVP through our website by August 15th. This helps us ensure everything is perfectly prepared for your arrival. You can find the response form on our dedicated RSVP page."
}, {
  question: "Is there a wedding registry?",
  answer: "Your presence at our celebration is the greatest gift of all. However, if you wish to honor us with a gift, we have curated a registry of items to help us start our new life together, which you can find linked on our homepage."
}];
export default function FrequentlyAskedQuestions() {
  return <section data-section-id="231402" id="frequently-asked" className="bg-secondary text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-3xl">
        <div className="text-center mb-12">
          <h2 className="font-default text-3xl md:text-4xl font-bold text-foreground mb-4 tracking-wide">
            Guest Information
          </h2>
          <p className="font-default text-muted-foreground text-lg italic">
            Everything you need to know about our celebration. If you have more questions, feel free to reach out to us directly.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => <AccordionItem key={index} value={`item-${index}`} data-index={index} className="border-border">
              <AccordionTrigger className="font-default text-foreground text-lg font-semibold hover:no-underline hover:text-primary data-[state=open]:[&>svg]:text-primary transition-colors py-5 tracking-tight">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="font-serif text-muted-foreground text-base leading-relaxed pb-5">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}